import React, { useContext } from "react";
import {
	Box,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	IconButton,
	Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CreatorContext } from "../../context/CreatorContext"; // Asegúrate de importar correctamente tu contexto
import fontIcons from "../../assets/font-glyphs/icons.json";
import { useTranslation } from "react-i18next";

const allIcons = [
	"AntDesign",
	"Entypo",
	"EvilIcons",
	"Feather",
	"FontAwesome",
	"FontAwesome5",
	"Fontisto",
	"Foundation",
	"Ionicons",
	"MaterialCommunityIcons",
	"MaterialIcons",
	"Octicons",
	"SimpleLineIcons",
	"Zocial",
].map((f) => ({ name: f, icons: Object.entries(fontIcons[f]) }));

export const ShowcaseDrawer = ({ isOpen, toggleDrawer, hideMenuIcon }) => {
	const { creator } = useContext(CreatorContext);
	const navigate = useNavigate();

	const { t } = useTranslation();

	const handleNavigation = (route) => {
		navigate(route);
		toggleDrawer(false);
	};

	const Icon = React.memo(({ family, name, selected, ...props }) => (
		<span
			style={{
				fontSize: 12,
				fontFamily:
					family === "FontAwesome5"
						? "'FontAwesome5', 'FontAwesome5_Regular', 'FontAwesome5Brands'"
						: family,
				color: !selected
					? creator.navigationTextColor
					: creator.color === creator.navigationColor
					? creator.navigationTextColor
					: creator.color,
				opacity: (
					hideMenuIcon !== undefined ? !hideMenuIcon : !creator.hideMenuTitle
				)
					? 1
					: 0,
			}}
			{...props}
		>
			{String.fromCodePoint(fontIcons[family][name])}
		</span>
	));

	const getIcon = (family, name, selected) => {
		return <Icon family={family} name={name} selected={selected} />;
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				padding: 2,
				mt: 3,
				"& *:not(span)": {
					fontFamily: creator.fontFamilyCap + "!important",
				},
			}}
		>
			<Typography
				sx={{
					fontSize: "8px",
					color: creator.navigationTextColor,
					fontWeight: "bold",
				}}
			>
				{t("general.hi")}
			</Typography>
			<Typography
				sx={{ fontSize: "8px", color: creator.navigationTextColor, mb: 2 }}
			>
				Anna
			</Typography>
			{creator.creatorPages
				.sort((a, b) => a.order - b.order)
				.filter((page) => page.visible)
				.map((page, index) => {
					return (
						<Box
							button
							key={index}
							onClick={() => handleNavigation(page.route)}
							sx={{
								display: "flex",
								mb: 1,
								alignItems: "center",
								gap: 1,
							}}
						>
							{getIcon(page.iconType, page.iconName, index === 0)}

							<Typography
								sx={{
									fontSize: "8px",
									color:
										index !== 0
											? creator.navigationTextColor
											: creator.color === creator.navigationColor
											? creator.navigationTextColor
											: creator.color,
									fontWeight: "bold",
									marginLeft: (
										hideMenuIcon !== undefined
											? !hideMenuIcon
											: !creator.hideMenuTitle
									)
										? 0
										: -2,
								}}
							>
								{page.name}
							</Typography>
						</Box>
					);
				})}
		</Box>
	);
};
